<template>
  <BimEngineeringChangeItemDetail></BimEngineeringChangeItemDetail>
  <!-- <TopBar></TopBar> -->
</template>

<script>
const BimEngineeringChangeItemDetail = () =>
  import(
    "../../components/tables/bimEngineeringChange/bimEngineeringChangeItemDetail/BimEngineeringChangeItemDetail.vue"
  );
export default {
  name: "test",
  components: {
    BimEngineeringChangeItemDetail,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style>
body {
  background: #666;
}
</style>
